module.exports = __webpack_public_path__ + "img/gall-9.81dd8949.jpg";